import React from 'react';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { Popout, PopoutProps } from 'src/components/Popout';
import { SlideDownHandler } from 'src/components/Animated';
import useStyles from './Sheet.styles';

export type SheetProps = PopoutProps & {
  onRequestClose: () => void;
};

export const Sheet: React.FC<SheetProps> = ({
  children,
  visible = false,
  onRequestClose,
  ...props
}) => {
  const s = useStyles();
  const insets = useSafeAreaInsets();

  return (
    <Popout visible={visible} onRequestClose={onRequestClose} backdrop={false} {...props}>
      <SlideDownHandler
        style={[
          s.sheet,
          {
            marginTop: Math.max(insets.top, 16),
            paddingBottom: Math.max(insets.bottom, 16),
          },
        ]}
        visible={visible}
        onRequestClose={onRequestClose}
      >
        {children}
      </SlideDownHandler>
    </Popout>
  );
};
